import * as aor from "react-admin";
import React from "react";
import { fetchEnd, fetchStart, translate, CREATE } from "react-admin";
import history from "../common/history";
import myRestClient from "../common/restClient";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TranslatedText from "./TranslatedText";
import { getUserCompany } from "../common/authClient";
import { withStyles } from "@material-ui/core";

const styles = theme => ({});
const login_company = parseInt(getUserCompany(), 10);

class CustomerDialog extends React.Component {
    state = {
        showConfirmDialog: false,
        showAlreadyDoneDialog: false,
        customerData: null,
        errorText: ""
    };

    asyncValidate = event => {
        this.setState({ errorText: "" });
        if (event.target.value !== "") {
            const message =
                "resources.customers.validation.notSpecialCharacter";
            const reg = /^[A-Za-z0-9]+$/;

            if (event.target.value && !reg.test(event.target.value)) {
                return this.setState({
                    errorText: this.props.translate(message)
                });
            }

            const params = {
                vatin: event.target.value,
                check_without_role: true
            };
            // const data =
            myRestClient("GET_ONE_BY_PARAMETERS", "customers", params).then(
                response => {
                    if (response && response.data && response.data.vatin) {
                        myRestClient(
                            "GET_ONE_BY_PARAMETERS",
                            "customers-mappings",
                            {
                                customer_id: response.data.id,
                                company_id: login_company
                            }
                        ).then(
                            map_response => {
                                if (map_response && map_response.data) {
                                    if (
                                        map_response.data.code === 400 // already_associated: 400
                                    ) {
                                        // found already associated
                                        this.setState({
                                            customerData: response.data,
                                            showConfirmDialog: false,
                                            showAlreadyDoneDialog: true
                                        });
                                    } else if (
                                        map_response.data.code === 200 // valid_association: 200,
                                    ) {
                                        // can be associated
                                        this.setState({
                                            customerData: response.data,
                                            showAlreadyDoneDialog: false,
                                            showConfirmDialog: true
                                        });
                                    }
                                }
                            },
                            err => {
                                console.log(err);
                                return null;
                            }
                        );
                    }
                },
                err => {
                    console.log(err);
                    return null;
                }
            );
        } else {
            // ERROR Mandatory field
            return this.setState({
                errorText: this.props.translate("validationRequired")
            });
        }
    };
    handleConfirmOk = () => {
        // const { history } = this.props;

        // Dispatch an action letting react-admin know a API call is ongoing
        fetchStart();
        const id = this.state.customerData.id;

        // create a customerMapping via API call
        myRestClient(CREATE, "customers-mappings", {
            data: {
                customer_id: parseInt(id, 10),
                company_id: login_company
            }
        })
            .then(response => {
                this.setState({
                    showConfirmDialog: false,
                    showAlreadyDoneDialog: false
                });
                history.push(`/customers/${id}/show`);
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    showConfirmDialog: false,
                    showAlreadyDoneDialog: false
                });
            })
            .finally(() => {
                // Dispatch an action letting react-admin know a API call has ended
                fetchEnd();
            });
    };

    handleConfirmCancel = () => {
        this.setState({
            showConfirmDialog: false,
            showAlreadyDoneDialog: false
        });
    };

    onChange() {}

    renderTextField() {
        return (
            <aor.TextInput
                style={{ width: 256 }}
                source="vatin"
                validate={[aor.required()]}
                label={this.props.translate("resources.customers.fields.vatin")}
                onBlur={this.asyncValidate}
                error={this.state.errorText.length === 0 ? false : true}
                helperText={this.state.errorText}
                onChange={this.onChange.bind(this)}
                format={v => (v ? v.toUpperCase() : "")}
            />
        );
    }
    renderDialogContent() {
        const record = this.state.customerData;
        return (
            <div>
                <p>Partita iva: {record.vatin}</p>
                <p>Cliente: {record.name}</p>
                {record.email ? <p>Email: {record.email}</p> : <p />}
            </div>
        );
    }
    renderDialog() {
        return this.state.showConfirmDialog === true ? (
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.showConfirmDialog}
            >
                <DialogTitle>
                    <b>
                        <TranslatedText resource_name="resources.customers.actions.associate.title" />
                    </b>
                </DialogTitle>
                <DialogContent>
                    <TranslatedText resource_name="resources.customers.actions.associate.content" />
                    {this.renderDialogContent()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleConfirmCancel} color="primary">
                        <TranslatedText resource_name="resources.customers.actions.associate.no" />
                    </Button>
                    <Button
                        onClick={this.handleConfirmOk}
                        variant="contained"
                        color="secondary"
                    >
                        <TranslatedText resource_name="resources.customers.actions.associate.yes" />
                    </Button>
                </DialogActions>
            </Dialog>
        ) : null;
    }
    renderAlreadyDoneDialog() {
        return this.state.showAlreadyDoneDialog === true ? (
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.showAlreadyDoneDialog}
            >
                <DialogTitle>
                    <b>
                        <TranslatedText resource_name="resources.customers.actions.associate.title" />
                    </b>
                </DialogTitle>
                <DialogContent>
                    <TranslatedText resource_name="resources.customers.actions.associate.content_warning" />
                    {this.renderDialogContent()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleConfirmCancel} color="primary">
                        <TranslatedText resource_name="resources.customers.actions.associate.cancel" />
                    </Button>
                </DialogActions>
            </Dialog>
        ) : null;
    }
    render() {
        return (
            <div>
                {this.renderTextField()}
                {this.renderDialog()}
                {this.renderAlreadyDoneDialog()}
            </div>
        );
    }
}

// export default CustomerDialog;
export default translate(withStyles(styles)(CustomerDialog));



// WEBPACK FOOTER //
// ./src/components/CustomerDialog.js